<div class="card rounded-4 h-100 d-flex flex-column">
    <div class="card-body text-center flex-grow-1">
        <span class="material-symbols-outlined custom-card-title" style="font-size: 48px;">
            {{ symbol }}
        </span>

        <h5 class="card-title mt-1">{{ header }}</h5>

        <p class="card-text">
            {{ description }}
        </p>
    </div>
</div>
